module.exports = __webpack_public_path__ + "img/Flask_web_app.c79f5c64.jpg";